import { render, staticRenderFns } from "./PopCheer.vue?vue&type=template&id=ae52a2f2&lang=pug"
import script from "./PopCheer.vue?vue&type=script&lang=js"
export * from "./PopCheer.vue?vue&type=script&lang=js"
import style0 from "./PopCheer.vue?vue&type=style&index=0&id=ae52a2f2&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports